import React from "react";
import ChallengeReport from "./ChallengeReport";
import AchievementsReport from "./AchievementsReport";
import OverallChallengeReport from "./OverAllChallengeReport";
import { Link } from "react-router-dom";

const AllReport = () => {
  return (
    <div className="p-2">
      <div className="" style={{marginLeft: '250px'}}>
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">All Reports</h1>
              </div>
              <div className="col-sm-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <a href="/#">Home</a>
                  </li>
                  <li className="breadcrumb-item active">
                    <Link to="/corporations">Corporations</Link>
                  </li>
                  <li className="breadcrumb-item active">All Reports</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex">
        <ChallengeReport />
        <AchievementsReport />
      </div>
      <OverallChallengeReport />
    </div>
  );
};

export default AllReport;
